const stringFilter = (str: string, search: string) => {
  return str.toLowerCase().includes(search.trim().toLowerCase());
};

export default stringFilter;
